import {
    LoggerConfig,
    LogMonitoringType,
    SentryErrorHandlerService
} from 'cidaas-logger-ui-sdk';
import version from '../../version.json';
import { environment } from '../environments/environment';

export const loggerConfig: LoggerConfig = {
    dsn: environment.logger_dsn || 'https://07ba498e9fbb4d268f694bb75fcde3ba@o1063928.ingest.sentry.io/4505231751184384',
    logLevel:environment.logger_log_level,
    monitoringType: environment.logger_monitoring_type  || LogMonitoringType.OFF,
    appName: 'default-hosted-pages-webapp',
    version: version.version
}

export const initEnvironmentLogger = () => {
    SentryErrorHandlerService.initSentry(loggerConfig);
}

